import { useIsDisplayOptimized } from '../transitional/context/DisplayOptimizedContext';
import { getDatePlaceholder } from '../transitional/utils/Locale/Locale';
const DISPLAY_OPTIMIZED_PLACEHOLDER = '--';
export const useComputedPlaceholder = placeholder => {
  const isDisplayOptimized = useIsDisplayOptimized();
  if (!placeholder && isDisplayOptimized) {
    return DISPLAY_OPTIMIZED_PLACEHOLDER;
  }
  return placeholder;
};
export const useComputedDateInputPlaceholder = format => {
  const isDisplayOptimized = useIsDisplayOptimized();
  if (isDisplayOptimized) {
    return DISPLAY_OPTIMIZED_PLACEHOLDER;
  }
  return getDatePlaceholder(format);
};